export enum FetchStatus {
  unloaded = 'unloaded',
  fetching = 'fetching',
  success = 'success',
  error = 'error',
}

export type FetchResult<T, E = string> = {
  status: FetchStatus
  lastFetch: string | null
  data?: T
  error?: E
}
